import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Slide, toast, ToastContainer } from "react-toastify";
import audio_finish from '../finish.mp3';
import warn from '../warn.mp3';

export default function AviaWarehouseScanner() {

    // ── Asosiy state ──
    const [trackingCode,   setTrackingCode]   = useState('');
    const [weight,         setWeight]         = useState('');
    const [showModal,      setShowModal]      = useState(false);
    const [modalData,      setModalData]      = useState({ trackingCode: '', weight: '' });
    const [clientId,       setClientId]       = useState('');
    const [productCode,    setProductCode]    = useState('');
    const [editMode,       setEditMode]       = useState(false);
    const [editingRecord,  setEditingRecord]  = useState(null);
    const [scanRecords,    setScanRecords]    = useState([]);
    const [currentPage,    setCurrentPage]    = useState(1);
    const [totalPages,     setTotalPages]     = useState(0);
    const [totalCount,     setTotalCount]     = useState(0);
    const [loading,        setLoading]        = useState(false);
    const [searchQuery,    setSearchQuery]    = useState('');
    const [isSaving,       setIsSaving]       = useState(false);
    const [modalBoxNumber, setModalBoxNumber] = useState('');

    // ── Avia-specific state ──
    const [serials,        setSerials]        = useState([]);
    const [selectedSerial, setSelectedSerial] = useState(null);
    const [boxNumber,      setBoxNumber]      = useState(1);
    const [existingBoxes,  setExistingBoxes]  = useState([]);
    const [serialLoading,  setSerialLoading]  = useState(true);

    // ── Serial manual override ──
    const [manualSerialSelected, setManualSerialSelected] = useState(false);
    const [pendingSerial,        setPendingSerial]        = useState(null);
    const [showSerialConfirm,    setShowSerialConfirm]    = useState(false);

    // ── Generate confirm ──
    const [genConfirm,     setGenConfirm]     = useState(false);
    const [generating,     setGenerating]     = useState(false);
    const [isGenerated,    setIsGenerated]    = useState(false);  // tanlangan partiya generatsiya qilinganmi

    const recordsPerPage = 100;

    // ── Refs ──
    const trackingInputRef    = useRef(null);
    const weightInputRef      = useRef(null);
    const clientIdInputRef    = useRef(null);
    const productCodeInputRef = useRef(null);
    const modalBoxInputRef    = useRef(null);
    const modalWeightInputRef = useRef(null);  // modal ichidagi weight uchun alohida ref
    const searchInputRef      = useRef(null);
    const searchTimeoutRef    = useRef(null);
    const isProcessingRef     = useRef(false);
    const focusTimerRef       = useRef(null);  // closeModal focus timer ni bekor qilish uchun

    // ── Translations ──
    const translations = {
        uzb: {
            langName: "O'zbekcha",
            title: 'Avia Ombor Skaner',
            scanPlaceholder: 'Barkodni bu yerga skanerlang...',
            weightPlaceholder: "Og'irlikni skanerlang yoki kiriting...",
            submitButton: 'Qabul qilish',
            noRecords: 'Hozircha scan qilinmagan.',
            trackingCodeLabel: 'Trek raqam',
            weightLabel: "Og'irligi",
            clientIdLabel: 'Mijoz kodi',
            statusLabel: 'Holati',
            statusCreated: 'Yaratilgan',
            statusUpdated: 'Yangilangan',
            timeLabel: 'Qabul qilish sanasi',
            modalTitle: "Ma'lumotlarni tasdiqlash",
            clientIdPlaceholder: 'Mijoz ID ni kiriting...',
            productCodeLabel: 'Mahsulot raqami (TN VED)',
            productCodePlaceholder: 'TN VED raqamini kiriting...',
            productCodeHint: "Raqam bo'yicha mahsulot nomi avtomatik topiladi",
            cancel: 'Bekor qilish',
            confirm: 'Qabul qilish',
            save: 'Saqlash',
            edit: 'Tahrirlash',
            search: 'Trek raqamni qidirish',
            showing: "Ko'rsatilmoqda",
            of: 'dan',
            records: 'yozuv',
            loading: 'Yuklanmoqda...',
            alreadyExists: "Bu trek kod allaqachon qabul qilingan! Qayta skanerlash mumkin emas!",
            clientIdLength: "Mijoz ID 6 ta belgidan iborat bo'lishi kerak (yoki 99XXXXXX)",
            successSaved: 'Muvaffaqiyatli saqlandi',
            successUpdated: 'Muvaffaqiyatli yangilandi',
            serverError: 'Xatolik',
            connectionError: "Server bilan bog'lanib bo'lmadi",
            editTimeExpired: 'Bu trek kod 24 soatdan oldin qabul qilingan, tahrirlash mumkin emas!',
            serialLabel: 'Partiya',
            serialNotFound: "Hozirgi vaqtga mos partiya topilmadi",
            boxLabel: 'Karobka №',
            boxNumberLabel: 'Karobka',
            productTitleLabel: 'Mahsulot nomi',
            lastDay: 'Oxirgi kun',
            prevBox: 'Oldingi',
            nextBox: 'Keyingi',
            boxHint: 'Mavjud karobkalar:',
            generateBtn: 'Generatsiya',
            generating: 'Yaratilmoqda...',
            generateConfirmTitle: 'Generatsiya qilish',
            generateConfirmMsg: 'partiyasi uchun invoice va QR kodlarni yaratishni xohlaysizmi?',
            generateConfirmOk: 'Ha, generatsiya qilish',
            generateSuccess: 'ta invoice yaratildi',
            fillField: "maydonini to'ldiring!",
            fillTrack: "Trek raqamni kiriting!",
            fillWeight: "Og'irlikni kiriting!",
            deleteConfirm: "Bu trek kodni o'chirishni tasdiqlaysizmi?",
            deleteSuccess: "Muvaffaqiyatli o'chirildi",
            deleteTimeExpired: "Bu trek kod 24 soatdan oldin qabul qilingan, o'chirib bo'lmaydi!",
            deleteLocationBlocked: "UZB, Yetkazib berilmoqda yoki Yetkazib berildi statusidagi trek kodni o'chirib bo'lmaydi!",
            editLocationBlocked: "UZB, Yetkazib berilmoqda yoki Yetkazib berildi statusidagi trek kodni o'zgartirib bo'lmaydi!",
            serialChangeTitle:   "Partiya almashtirilmoqda",
            serialChangeMsg:     "Bu amalni ortga qaytarib bo'lmaydi. Tanlangan partiyada davom etasizmi?",
            serialChangeConfirm: "Ha, almashtirish",
        },
        rus: {
            langName: 'Русский',
            title: 'Авиа Склад Сканер',
            scanPlaceholder: 'Отсканируйте штрих-код здесь...',
            weightPlaceholder: 'Отсканируйте или введите вес...',
            submitButton: 'Принять',
            noRecords: 'Записей пока нет.',
            trackingCodeLabel: 'Трек-номер',
            weightLabel: 'Вес',
            clientIdLabel: 'Код клиента',
            statusLabel: 'Статус',
            statusCreated: 'Создан',
            statusUpdated: 'Обновлен',
            timeLabel: 'Дата приёма',
            modalTitle: 'Подтверждение данных',
            clientIdPlaceholder: 'Введите ID клиента...',
            productCodeLabel: 'Код товара (ТН ВЭД)',
            productCodePlaceholder: 'Введите код ТН ВЭД...',
            productCodeHint: 'Название товара будет найдено автоматически по коду',
            cancel: 'Отмена',
            confirm: 'Принять',
            save: 'Сохранить',
            edit: 'Редактировать',
            search: 'Поиск по трек-номеру',
            showing: 'Показано',
            of: 'из',
            records: 'записей',
            loading: 'Загрузка...',
            alreadyExists: 'Этот трек-код уже принят! Повторное сканирование невозможно!',
            clientIdLength: 'ID клиента должен состоять из 6 символов (или 99XXXXXX)',
            successSaved: 'Успешно сохранено',
            successUpdated: 'Успешно обновлено',
            serverError: 'Ошибка',
            connectionError: 'Не удалось связаться с сервером',
            editTimeExpired: 'Редактирование невозможно: прошло более 24 часов!',
            serialLabel: 'Партия',
            serialNotFound: 'Партия не найдена',
            boxLabel: 'Коробка №',
            boxNumberLabel: 'Коробка',
            productTitleLabel: 'Наименование товара',
            lastDay: 'Последний день',
            prevBox: 'Пред.',
            nextBox: 'След.',
            boxHint: 'Существующие коробки:',
            generateBtn: 'Генерация',
            generating: 'Создаётся...',
            generateConfirmTitle: 'Генерация',
            generateConfirmMsg: 'партии создать инвойсы и QR-коды?',
            generateConfirmOk: 'Да, генерировать',
            generateSuccess: 'инвойсов создано',
            fillField: 'обязательное поле!',
            fillTrack: 'Введите трек-номер!',
            fillWeight: 'Введите вес!',
            deleteConfirm: 'Вы уверены, что хотите удалить этот трек-код?',
            deleteSuccess: 'Успешно удалено',
            deleteTimeExpired: 'Удаление невозможно: прошло более 24 часов!',
            deleteLocationBlocked: 'Нельзя удалить трек-код со статусом В Узбекистане, В пути или Доставлено!',
            editLocationBlocked: 'Нельзя редактировать трек-код со статусом В Узбекистане, В пути или Доставлено!',
            serialChangeTitle:   'Смена партии',
            serialChangeMsg:     'Это действие нельзя отменить. Продолжить со сканированием в выбранной партии?',
            serialChangeConfirm: 'Да, изменить',
            downloadQR: 'Скачать QR PDF',
        },
        chn: {
            langName: '中国人',
            title: '航空仓库扫描',
            scanPlaceholder: '在此扫描条形码...',
            weightPlaceholder: '扫描或输入重量...',
            submitButton: '接受',
            noRecords: '暂无记录。',
            trackingCodeLabel: '跟踪号码',
            weightLabel: '重量',
            clientIdLabel: '客户代码',
            statusLabel: '状态',
            statusCreated: '已创建',
            statusUpdated: '已更新',
            timeLabel: '接收日期',
            modalTitle: '确认数据',
            clientIdPlaceholder: '输入客户ID...',
            productCodeLabel: '商品编码 (HS)',
            productCodePlaceholder: '输入HS编码...',
            productCodeHint: '产品名称将根据代码自动找到',
            cancel: '取消',
            confirm: '接受',
            save: '保存',
            edit: '编辑',
            search: '搜索跟踪号码',
            showing: '显示',
            of: '的',
            records: '记录',
            loading: '加载中...',
            alreadyExists: '此跟踪代码已存在！无法重复扫描！',
            clientIdLength: '客户ID必须为6个字符 (或 99XXXXXX)',
            successSaved: '成功保存',
            successUpdated: '成功更新',
            serverError: '错误',
            connectionError: '无法连接到服务器',
            editTimeExpired: '此跟踪代码已超过24小时，无法编辑！',
            serialLabel: '批次',
            serialNotFound: '未找到批次',
            boxLabel: '箱号',
            boxNumberLabel: '箱子',
            productTitleLabel: '产品名称',
            lastDay: '最后一天',
            prevBox: '上一个',
            nextBox: '下一个',
            boxHint: '现有箱子:',
            generateBtn: '生成',
            generating: '创建中...',
            generateConfirmTitle: '生成发票',
            generateConfirmMsg: '批次生成发票和QR码？',
            generateConfirmOk: '是，生成',
            generateSuccess: '个发票已创建',
            fillField: '为必填项！',
            downloadQR: '下载QR PDF',
            fillTrack: '请输入跟踪号码！',
            fillWeight: '请输入重量！',
            deleteConfirm: '确认删除此跟踪码？',
            deleteSuccess: '成功删除',
            deleteTimeExpired: '无法删除：已超过24小时！',
            deleteLocationBlocked: '无法删除：状态为在乌兹别克斯坦、运输中或已送达！',
            editLocationBlocked: '无法编辑：状态为在乌兹别克斯坦、运输中或已送达！',
            serialChangeTitle:   '更改批次',
            serialChangeMsg:     '此操作无法撤销。是否继续扫描所选批次？',
            serialChangeConfirm: '是，更改',
        },
        eng: {
            langName: 'English',
            title: 'Avia Warehouse Scanner',
            scanPlaceholder: 'Scan barcode here...',
            weightPlaceholder: 'Scan or enter weight...',
            submitButton: 'Accept',
            noRecords: 'No records yet.',
            trackingCodeLabel: 'Track Number',
            weightLabel: 'Weight',
            clientIdLabel: 'Client Code',
            statusLabel: 'Status',
            statusCreated: 'Created',
            statusUpdated: 'Updated',
            timeLabel: 'Acceptance Date',
            modalTitle: 'Confirm Data',
            clientIdPlaceholder: 'Enter Client ID...',
            productCodeLabel: 'Product Code (HS Code)',
            productCodePlaceholder: 'Enter HS code...',
            productCodeHint: 'Product name will be found automatically by code',
            cancel: 'Cancel',
            confirm: 'Accept',
            save: 'Save',
            edit: 'Edit',
            search: 'Search track number',
            showing: 'Showing',
            of: 'of',
            records: 'records',
            loading: 'Loading...',
            alreadyExists: 'This tracking code already exists! Cannot scan again!',
            clientIdLength: 'Client ID must be 6 characters (or 99XXXXXX)',
            successSaved: 'Successfully saved',
            successUpdated: 'Successfully updated',
            serverError: 'Error',
            connectionError: 'Could not connect to server',
            editTimeExpired: 'This tracking code was scanned more than 24 hours ago!',
            serialLabel: 'Batch',
            serialNotFound: 'No batch found',
            boxLabel: 'Box №',
            boxNumberLabel: 'Box',
            productTitleLabel: 'Product Name',
            lastDay: 'Last day',
            prevBox: 'Prev',
            nextBox: 'Next',
            boxHint: 'Existing boxes:',
            generateBtn: 'Generate',
            generating: 'Generating...',
            generateConfirmTitle: 'Generate Invoices',
            generateConfirmMsg: 'batch — generate invoices and QR codes?',
            generateConfirmOk: 'Yes, generate',
            generateSuccess: 'invoices created',
            fillField: 'field is required!',
            downloadQR: 'Download QR PDF',
            fillTrack: 'Enter tracking number!',
            fillWeight: 'Enter weight!',
            deleteConfirm: 'Are you sure you want to delete this tracking code?',
            deleteSuccess: 'Successfully deleted',
            deleteTimeExpired: 'Cannot delete: more than 24 hours have passed!',
            deleteLocationBlocked: 'Cannot delete: tracking code is in UZB, On the way, or Delivered status!',
            editLocationBlocked: 'Cannot edit: tracking code is in UZB, On the way, or Delivered status!',
            serialChangeTitle:   'Change Batch',
            serialChangeMsg:     'This action cannot be undone. Continue scanning with the selected batch?',
            serialChangeConfirm: 'Yes, change',
        }
    };

    const [language,     setLanguage]     = useState('uzb');
    const [showLangMenu, setShowLangMenu] = useState(false);
    const [boxDropdownOpen, setBoxDropdownOpen] = useState(false);
    const boxDropdownRef = useRef(null);
    const t = translations[language];
    const langFlags = { uzb: '🇺🇿', rus: '🇷🇺', chn: '🇨🇳', eng: '🇺🇸' };

    const API_BASE_URL = 'https://fx.softmakon.uz/api';

    // ── Audio ──
    const playSuccess = () => { try { new Audio(audio_finish).play(); } catch {} };
    const playError   = () => { try { new Audio(warn).play(); } catch {} };

    // ── Client ID ──
    const getClientIdMaxLength = () => clientId.startsWith('99') ? 9 : 6;
    const isClientIdValid = (v = clientId) => v.startsWith('99') ? v.length >= 7 : v.length === 6;

    // Mahalliy sana (UTC emas!) — Toshkent UTC+5
    const todayStr = () => {
        const d = new Date();
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${y}-${m}-${day}`;
    };
    const fmtDateShort = (iso) => {
        if (!iso) return '';
        const [y, m, d] = iso.split('-');
        return `${d}.${m}.${y}`;
    };

    // ── Serial qo'lda o'zgartirish ─────────────────────────────────────────────
    // Faqat avtomatik tanlangan partiyadan KEYINGI bitta partiyaga ruxsat beriladi
    const handleSerialChange = (e) => {
        const sn = e.target.value;
        const serial = serials.find(s => (s.serial_number || s.title) === sn);
        if (!serial) return;
        if ((selectedSerial?.serial_number || selectedSerial?.title) === sn) return;

        // Avtomatik tanlangan (bugungi sana bo'yicha) partiyani topamiz
        const today = todayStr();
        const autoSerial = serials.find(s => s.datefrom <= today && s.dateto >= today)
            || serials[serials.length - 1]
            || serials[0];

        // "Keyingi" partiya — datefrom bo'yicha avtomatik partiyadan KATTA bo'lgan eng kichigi
        // Index ga bog'liq emas — API tartibi muhim emas (descending kelsa ham to'g'ri ishlaydi)
        const nextSerial = serials
            .filter(s => (s.datefrom || '') > (autoSerial?.datefrom || ''))
            .sort((a, b) => (a.datefrom || '').localeCompare(b.datefrom || ''))[0];

        const targetSn = serial.serial_number || serial.title;
        const nextSn   = nextSerial?.serial_number || nextSerial?.title;

        // Faqat bitta keyingi partiyaga ruxsat
        if (!nextSerial || targetSn !== nextSn) return;

        setPendingSerial(serial);
        setShowSerialConfirm(true);
    };

    const confirmSerialChange = () => {
        if (!pendingSerial) return;
        setSelectedSerial(pendingSerial);
        setManualSerialSelected(true);
        setShowSerialConfirm(false);
        const sn = pendingSerial.serial_number || pendingSerial.title;
        setPendingSerial(null);
        fetchAllBoxes(sn, true);
        fetchTrackingRecords(1, searchQuery, sn);
    };

    // Agar bugungi sana avtomatik partiya bilan manual tanlangan partiya bir xil bo'lsa —
    // manual override bekor qilinadi (yangi kun o'tganda auto-switch ishlaydi)
    const resetManualIfMatches = (autoSerial) => {
        if (!autoSerial || !manualSerialSelected) return;
        const autoSn   = autoSerial.serial_number || autoSerial.title;
        const curSn    = selectedSerial?.serial_number || selectedSerial?.title;
        if (autoSn === curSn) setManualSerialSelected(false);
    };

    // Scan uchun sana: agar manual tanlangan bo'lsa — datefrom T00:00:00
    // (datefrom katta, kichik yoki teng bo'lishidan qat'iy nazar)
    // Misol: bugun 29.01, 194-partiya datefrom=30.01 → scan 30.01T00:00:00 bilan saqlanadi
    const getScanDate = () => {
        if (manualSerialSelected && selectedSerial?.datefrom) {
            return `${selectedSerial.datefrom}T00:00:00`;
        }
        return null;
    };

    // ── Fetch serials ──
    const fetchSerials = async () => {
        setSerialLoading(true);
        try {
            const r    = await fetch(`${API_BASE_URL}/avia-tracking-serial/`);
            if (!r.ok) throw new Error();
            const data = await r.json();
            const list = Array.isArray(data) ? data : (data.results || []);
            // title → serial_number normallashtirish
            list.forEach(s => { if (!s.serial_number && s.title) s.serial_number = s.title; });
            setSerials(list);
            const today = todayStr();
            const active = list.find(s => s.datefrom <= today && s.dateto >= today);
            const cur = active || list[list.length - 1] || list[0] || null;

            // Manual tanlangan bo'lsa — avtomatik o'zgartirmaymiz
            // Faqat agar avtomatik partiya manual tanlangan partiyaga to'g'ri kelsa, reset qilamiz
            if (!manualSerialSelected) {
                setSelectedSerial(cur);
            } else {
                resetManualIfMatches(cur);
                // Serials listini yangilaymiz, lekin selectedSerial o'zgarmaydi
            }
        } catch {
            setSerials([]);
        } finally {
            setSerialLoading(false);
        }
    };

    // ── Fetch records ──
    // ── Barcha karobka raqamlarini alohida fetch qilish (pagination'ga bog'liq emas) ──
    const fetchAllBoxes = useCallback(async (serial, initBox = false) => {
        if (!serial) return;
        try {
            // Dedicated endpoint — pagination yo'q, faqat box raqamlar
            const r = await fetch(`${API_BASE_URL}/avia-scan/boxes/?serial_number=${encodeURIComponent(serial)}`);
            if (!r.ok) return;
            const data = await r.json();
            const boxes = (data.boxes || []).sort((a, b) => (parseInt(a) || 0) - (parseInt(b) || 0));
            setExistingBoxes(boxes);
            if (initBox) {
                const maxBox = Math.max(...boxes.map(b => parseInt(b) || 0), 0);
                setBoxNumber(maxBox || 1);
            }
        } catch {}
    }, []);

    const fetchTrackingRecords = useCallback(async (page = 1, search = '', serial = '') => {
        setLoading(true);
        try {
            let url = `${API_BASE_URL}/avia-scan/?page=${page}&page_size=${recordsPerPage}`;
            if (search.trim()) url += `&search=${encodeURIComponent(search.trim())}`;
            if (serial)        url += `&serial_number=${encodeURIComponent(serial)}`;

            const r    = await fetch(url);
            const ct   = r.headers.get('content-type');
            if (!ct || !ct.includes('application/json')) {
                toast.error(t.connectionError, { position: "top-right", transition: Slide, autoClose: 5000 });
                return;
            }
            if (!r.ok) throw new Error();
            const data    = await r.json();
            const results = data.results || data || [];
            setScanRecords(results);
            setTotalPages(data.total_pages || 0);
            setTotalCount(data.count || 0);
            setCurrentPage(page);
            setTimeout(() => {
                if (searchInputRef.current && search.trim()) searchInputRef.current.focus();
            }, 50);
        } catch (error) {
            if (error.message?.includes('Failed to fetch'))
                toast.error(t.connectionError, { position: "top-right", transition: Slide, autoClose: 5000 });
        } finally {
            setLoading(false);
        }
    }, [t]);

    // ── Init ──
    useEffect(() => { fetchSerials(); }, []);
    useEffect(() => {
        if (!selectedSerial) return;
        const sn = selectedSerial.serial_number || selectedSerial.title;

        setExistingBoxes([]);
        setBoxNumber(1);
        fetchTrackingRecords(1, searchQuery, sn);
        // Barcha karobkalarni alohida yuklaymiz (pagination'dan mustaqil)
        // initBox=true: faqat shu safar boxNumber ni oxirgi karobkaga o'rnatadi
        fetchAllBoxes(sn, true);
        // Generatsiya holatini tekshirish
        fetch(`${API_BASE_URL}/avia-invoices/`)
            .then(r => r.json())
            .then(data => {
                const list = Array.isArray(data) ? data : [];
                const found = list.find(x => (x.serial_number || x.title) === sn);
                setIsGenerated(found?.is_generated || false);
            })
            .catch(() => setIsGenerated(false));
    }, [selectedSerial]);


    useEffect(() => { trackingInputRef.current?.focus(); }, []);
    useEffect(() => {
        const handler = (e) => {
            if (boxDropdownRef.current && !boxDropdownRef.current.contains(e.target)) {
                setBoxDropdownOpen(false);
            }
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, []);

    // ── Lang menu close on outside click ──
    useEffect(() => {
        const h = (e) => { if (showLangMenu && !e.target.closest('.lang-selector')) setShowLangMenu(false); };
        document.addEventListener('click', h);
        return () => document.removeEventListener('click', h);
    }, [showLangMenu]);

    // ── Modal scroll lock ──
    useEffect(() => {
        if (showModal) {
            const y = window.scrollY;
            document.body.style.position = 'fixed';
            document.body.style.top      = `-${y}px`;
            document.body.style.width    = '100%';
        } else {
            const y = document.body.style.top;
            document.body.style.position = '';
            document.body.style.top      = '';
            document.body.style.width    = '';
            if (y) window.scrollTo(0, parseInt(y) * -1);
        }
    }, [showModal]);

    useEffect(() => { if (showModal) clientIdInputRef.current?.focus(); }, [showModal]);

    // ── Search ──
    const handleSearch = (e) => {
        const v = e.target.value;
        setSearchQuery(v);
        clearTimeout(searchTimeoutRef.current);
        searchTimeoutRef.current = setTimeout(
            () => fetchTrackingRecords(1, v, selectedSerial?.serial_number || ''),
            500
        );
    };

    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) {
            fetchTrackingRecords(page, searchQuery, selectedSerial?.serial_number || selectedSerial?.title || '');
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    // ── Scan inputs keydown ──
    const handleTrackingKeyDown = (e) => {
        if (e.key === 'Enter' && !isProcessingRef.current) {
            e.preventDefault();
            if (!trackingCode.trim()) return;
            clearTimeout(focusTimerRef.current);
            weightInputRef.current?.focus();
        }
    };

    const handleWeightKeyDown = (e) => {
        if (e.key === 'Enter' && !isProcessingRef.current) {
            e.preventDefault();
            if (!trackingCode.trim()) {
                toast.warning(t.fillTrack, { position: "top-right", transition: Slide, autoClose: 2500 });
                trackingInputRef.current?.focus(); return;
            }
            if (!weight.trim()) return;
            isProcessingRef.current = true;
            openModal();
            setTimeout(() => { isProcessingRef.current = false; }, 500);
        }
    };

    // ── Modal enter navigation ──
    const makeEnterNav = (fieldLabel, nextRef) => (e) => {
        if (e.key !== 'Enter') return;
        e.preventDefault();
        if (!e.target.value?.trim()) {
            toast.warning(`"${fieldLabel}" ${t.fillField}`, { position: "top-right", transition: Slide, autoClose: 2500 });
            playError(); return;
        }
        nextRef?.current?.focus();
    };

    const handleLastEnter = (e) => {
        if (e.key === 'Enter') { e.preventDefault(); handleSubmit(); }
    };

    // ── Modal open/close ──
    const openModal = () => {
        setModalData({ trackingCode: trackingCode.trim().toUpperCase(), weight: weight.trim() });
        setShowModal(true);
        setClientId('');
        setProductCode('');
        setEditMode(false);
        setEditingRecord(null);
    };

    const openEditModal = (record) => {
        const t2 = new Date(record.scannerUpdatedAt || record.createdAt || record.create_date).getTime();
        if ((Date.now() - t2) / 36e5 > 24) {
            toast.error(t.editTimeExpired, { position: "top-right", transition: Slide, autoClose: 4000 });
            playError(); return;
        }
        setModalData({ trackingCode: record.trackingNumber || record.track_code, weight: record.weight || '' });
        setClientId(record.clientCode || record.code || '');
        setModalBoxNumber(String(record.box_number || ''));
        setProductCode('');
        setEditingRecord(record);
        setEditMode(true);
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
        setModalData({ trackingCode: '', weight: '' });
        setClientId('');
        setProductCode('');
        setEditMode(false);
        setEditingRecord(null);
        setModalBoxNumber('');
        setTrackingCode('');
        setWeight('');
        clearTimeout(focusTimerRef.current);
        focusTimerRef.current = setTimeout(() => trackingInputRef.current?.focus(), 300);
    };

    // ── Validate client via API ──
    const validateClientId = async (code) => {
        // 99 bilan boshlanadigan kodlar uchun API ga murojaat kerak emas
        // clientCode = "010682", xonid = original kod
        if (code.startsWith('99')) {
            return { client_id: '010682', xonid: code };
        }
        try {
            const r    = await fetch(`${API_BASE_URL}/v1/userid/?client_id=${code}`);
            if (!r.ok) return { client_id: null, xonid: null };
            const data = await r.json();
            return {
                client_id: data?.client_id || null,
                xonid:     data?.xonid     || null,
            };
        } catch { return { client_id: null, xonid: null }; }
    };

    // ── Delete ──
    const PROTECTED_LOCATIONS = ['uzb', 'ontheway', 'delivered'];

    const handleDelete = async (record) => {
        if (PROTECTED_LOCATIONS.includes(record.location)) {
            toast.error(t.deleteLocationBlocked, { position: "top-right", transition: Slide, autoClose: 4000 });
            playError(); return;
        }
        const scanTime = new Date(record.scannerUpdatedAt || record.createdAt || record.create_date).getTime();
        if ((Date.now() - scanTime) / 36e5 > 24) {
            toast.error(t.deleteTimeExpired, { position: "top-right", transition: Slide, autoClose: 4000 });
            playError(); return;
        }
        if (!window.confirm(t.deleteConfirm)) return;
        try {
            const r = await fetch(`${API_BASE_URL}/avia-scan/${record.id}/`, { method: 'DELETE' });
            if (!r.ok) throw new Error('Server xatosi');
            toast.success(t.deleteSuccess, { position: "top-right", transition: Slide, autoClose: 3000 });
            playSuccess();
            fetchTrackingRecords(currentPage, searchQuery, selectedSerial?.serial_number || selectedSerial?.title || '');
            fetchAllBoxes(selectedSerial?.serial_number || selectedSerial?.title || '');
        } catch (error) {
            toast.error(`${t.serverError}: ${error.message}`, { position: "top-right", transition: Slide, autoClose: 3000 });
            playError();
        }
    };

    // ── Save ──
    const handleSubmit = async () => {
        if (!modalData.trackingCode.trim()) {
            toast.warning(t.fillTrack, { position: "top-right", transition: Slide, autoClose: 2500 }); playError(); return;
        }
        if (!modalData.weight.trim() || parseFloat(String(modalData.weight).replace(',', '.')) <= 0) {
            toast.warning(t.fillWeight, { position: "top-right", transition: Slide, autoClose: 2500 }); playError(); return;
        }
        if (!productCode.trim()) {
            toast.warning(`"${t.productCodeLabel}" ${t.fillField}`, { position: "top-right", transition: Slide, autoClose: 2500 });
            playError();
            productCodeInputRef.current?.focus();
            return;
        }
        if (!isClientIdValid()) {
            toast.error(t.clientIdLength, { position: "top-right", transition: Slide, autoClose: 3000 }); playError(); return;
        }
        if (!editMode) {
            const dup = scanRecords.some(r =>
                (r.trackingNumber || r.track_code || '').toLowerCase() === modalData.trackingCode.toLowerCase()
            );
            if (dup) {
                toast.error(t.alreadyExists, { position: "top-right", transition: Slide, autoClose: 4000 }); playError(); return;
            }
        }
        if (editMode && editingRecord) {
            const t2 = new Date(editingRecord.scannerUpdatedAt || editingRecord.createdAt || editingRecord.create_date).getTime();
            if ((Date.now() - t2) / 36e5 > 24) {
                toast.error(t.editTimeExpired, { position: "top-right", transition: Slide, autoClose: 4000 }); playError(); closeModal(); return;
            }
        }

        setIsSaving(true);
        await new Promise(r => setTimeout(r, 200));
        const validated = await validateClientId(clientId.trim());
        if (!validated.client_id) {
            toast.error(t.clientIdLength, { position: "top-right", transition: Slide, autoClose: 3000 });
            playError(); setIsSaving(false); return;
        }

        try {
            // Manual tanlangan va datefrom < bugun bo'lsa → backdated sana
            const scanDate = getScanDate();

            const body = {
                trackingNumber: modalData.trackingCode,
                clientCode:     validated.client_id,
                weight:         parseFloat(String(modalData.weight).replace(',', '.')) || 0,
                serial_number:  selectedSerial?.serial_number || selectedSerial?.title || '',
                box_number:     editMode ? modalBoxNumber : String(boxNumber),
                product_code:   productCode,
                ...(validated.xonid ? { xonid: validated.xonid } : {}),
                ...(scanDate && !editMode ? { scan_date: scanDate } : {}),
            };
            if (editMode && editingRecord) body.id = editingRecord.id;

            const url    = editMode ? `${API_BASE_URL}/avia-scan/${editingRecord.id}/` : `${API_BASE_URL}/avia-scan/`;
            const method = editMode ? 'PUT' : 'POST';
            const r      = await fetch(url, { method, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
            if (!r.ok) throw new Error('Server xatosi');

            toast.success(editMode ? t.successUpdated : t.successSaved, { position: "top-right", transition: Slide, autoClose: 3000 });
            playSuccess();
            closeModal();
            fetchTrackingRecords(currentPage, searchQuery, selectedSerial?.serial_number || selectedSerial?.title || '');
            fetchAllBoxes(selectedSerial?.serial_number || selectedSerial?.title || '');
        } catch (error) {
            toast.error(`${t.serverError}: ${error.message}`, { position: "top-right", transition: Slide, autoClose: 3000 }); playError();
        } finally { setIsSaving(false); }
    };

    // ── Generate ──
    const doGenerate = async () => {
        if (!selectedSerial) return;
        setGenConfirm(false);
        setGenerating(true);
        try {
            const r    = await fetch(`${API_BASE_URL}/avia-invoices/generate/${selectedSerial.serial_number || selectedSerial.title}/`, { method: 'POST' });
            const data = await r.json();
            if (data.success) {
                toast.success(`${data.boxes_generated} ${t.generateSuccess} ✅`, { position: "top-right", transition: Slide, autoClose: 5000 });
                setIsGenerated(true);
            }
            else toast.error(data.error || t.serverError);
        } catch { toast.error(t.connectionError); }
        finally { setGenerating(false); }
    };

    // ── Helpers ──
    const getStatusBadge = (record) => {
        const cr = record.createdAt || record.create_date;
        const up = record.scannerUpdatedAt;
        if (!cr || !up) return { text: t.statusCreated, color: 'bg-blue-100 text-blue-800' };
        if (Math.abs(new Date(up) - new Date(cr)) > 1000) return { text: t.statusUpdated, color: 'bg-orange-100 text-orange-800' };
        return { text: t.statusCreated, color: 'bg-blue-100 text-blue-800' };
    };

    const formatDate = (d) => {
        if (!d) return '';
        return new Date(d).toLocaleString('en-GB', {
            day: '2-digit', month: '2-digit', year: 'numeric',
            hour: '2-digit', minute: '2-digit', hour12: false
        }).replace(',', '');
    };

    const isLastDay = (s) => s?.dateto === todayStr();

    const getPageNumbers = () => {
        const ps = [];
        if (totalPages <= 5) { for (let i = 1; i <= totalPages; i++) ps.push(i); }
        else if (currentPage <= 3)            { for (let i = 1; i <= 4; i++) ps.push(i); ps.push('...', totalPages); }
        else if (currentPage >= totalPages-2) { ps.push(1, '...'); for (let i = totalPages-3; i <= totalPages; i++) ps.push(i); }
        else ps.push(1, '...', currentPage-1, currentPage, currentPage+1, '...', totalPages);
        return ps;
    };

    const canSubmit = trackingCode.trim() && weight.trim();

    // ═══════════════════════════════════════════════════════
    // RENDER
    // ═══════════════════════════════════════════════════════
    return (
        <div className="min-h-screen bg-gray-50">
            <ToastContainer />

            {/* ── Header ── */}
            <div className="bg-white border-b border-gray-200 px-6 py-4">
                <div className="max-w-7xl mx-auto flex justify-between items-center gap-4 flex-wrap">
                    <h1 className="text-2xl font-bold text-gray-800">{t.title}</h1>

                    <div className="flex items-center gap-4 flex-wrap">

                        {/* ── Partiya select ── */}
                        <div className="flex flex-col gap-1">
                            <label className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
                                {t.serialLabel}
                            </label>
                            {serialLoading ? (
                                <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600" />
                            ) : (
                                <>
                                    <div className="relative">
                                        <select
                                            value={selectedSerial?.serial_number || selectedSerial?.title || ''}
                                            onChange={handleSerialChange}
                                            className="appearance-none w-full pl-4 pr-10 py-2.5 border-2 border-gray-300 rounded-xl focus:outline-none focus:border-blue-500 font-bold text-base bg-white cursor-pointer min-w-[180px]"
                                            style={{ color: manualSerialSelected ? '#7c3aed' : isLastDay(selectedSerial) ? '#b91c1c' : '#1e40af' }}
                                        >
                                            {serials.length === 0 && <option value="">{t.serialNotFound}</option>}
                                            {serials.map(s => {
                                                const sn = s.serial_number || s.title;
                                                return <option key={sn} value={sn}>{sn}</option>;
                                            })}
                                        </select>
                                        <svg className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400"
                                             fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7"/>
                                        </svg>
                                    </div>
                                    {selectedSerial && (() => {
                                        const today   = todayStr();
                                        const isActive = selectedSerial.datefrom <= today && selectedSerial.dateto >= today;
                                        const isFuture = selectedSerial.datefrom > today;
                                        const isLast   = isLastDay(selectedSerial);
                                        return (
                                            <span className={`text-xs font-semibold mt-0.5 ${isLast ? 'text-red-600' : isActive ? 'text-green-700' : isFuture ? 'text-purple-600' : 'text-orange-500'}`}>
                                                {fmtDateShort(selectedSerial.datefrom)} — {fmtDateShort(selectedSerial.dateto)}
                                                {isLast   && <span className="ml-1"> — {t.lastDay}</span>}
                                                {!isActive && !isFuture && <span className="ml-1"> — {t.oldPartyText}</span>}
                                            </span>
                                        );
                                    })()}
                                </>
                            )}
                        </div>

                        {/* ── Karobka select + next button ── */}
                        <div className="flex flex-col gap-1">
                            <label className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
                                {t.boxLabel}
                            </label>

                            {/* Custom dropdown — HTML select ishlatilmaydi */}
                            {existingBoxes.length > 0 ? (
                                <div className="relative" ref={boxDropdownRef}>
                                    {/* Trigger */}
                                    <button
                                        type="button"
                                        onClick={() => setBoxDropdownOpen(o => !o)}
                                        className="w-full pl-4 pr-10 py-2.5 border-2 border-gray-300 rounded-xl font-bold text-base bg-white cursor-pointer text-blue-700 min-w-[120px] text-left focus:outline-none focus:border-blue-500 flex items-center justify-between"
                                    >
                                        <span>
                                            {boxNumber}
                                            {!existingBoxes.includes(String(boxNumber)) && !existingBoxes.includes(boxNumber) && (
                                                <span className="text-xs text-gray-400 ml-1">(yangi)</span>
                                            )}
                                        </span>
                                        <svg className={`w-4 h-4 text-gray-400 transition-transform ${boxDropdownOpen ? 'rotate-180' : ''}`}
                                             fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7"/>
                                        </svg>
                                    </button>
                                    {/* Dropdown list */}
                                    {boxDropdownOpen && (
                                        <div className="absolute z-50 mt-1 w-full bg-white border-2 border-blue-300 rounded-xl shadow-lg overflow-y-auto"
                                             style={{ maxHeight: '220px' }}>
                                            {!existingBoxes.includes(String(boxNumber)) && !existingBoxes.includes(boxNumber) && (
                                                <div
                                                    onClick={() => { setBoxDropdownOpen(false); }}
                                                    className="px-4 py-2.5 cursor-pointer font-bold text-blue-700 bg-blue-50 border-b border-blue-100 hover:bg-blue-100"
                                                >
                                                    {boxNumber} <span className="text-xs text-gray-400">(yangi)</span>
                                                </div>
                                            )}
                                            {existingBoxes.map(b => (
                                                <div
                                                    key={b}
                                                    onClick={() => { setBoxNumber(Number(b)); setBoxDropdownOpen(false); }}
                                                    className={`px-4 py-2.5 cursor-pointer font-bold hover:bg-blue-50 transition-colors ${String(b) === String(boxNumber) ? 'bg-blue-100 text-blue-700' : 'text-gray-700'}`}
                                                >
                                                    {b}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <div className="px-4 py-2.5 border-2 border-gray-200 rounded-xl bg-gray-50 font-bold text-xl text-blue-700 text-center min-w-[120px]">
                                    {boxNumber}
                                </div>
                            )}

                            {/* Keyingi karobkaga o'tish tugmasi */}
                            <button
                                onClick={() => setBoxNumber(n => n + 1)}
                                disabled={!existingBoxes.includes(String(boxNumber)) && !existingBoxes.includes(boxNumber)}
                                className="mt-1 w-full py-1.5 px-3 border-2 border-blue-200 text-blue-600 rounded-xl text-xs font-semibold hover:bg-blue-50 hover:border-blue-400 transition-colors flex items-center justify-center gap-1 disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-transparent disabled:hover:border-blue-200"
                            >
                                <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M9 18l6-6-6-6"/>
                                </svg>
                                {t.nextBox}
                            </button>
                        </div>

                        {/* ── Generatsiya yoki yuklab olish tugmasi ── */}
                        <div className="flex flex-col justify-end">
                            {isGenerated ? (
                                <button
                                    onClick={() => window.open(`${API_BASE_URL}/avia-invoices/download/${selectedSerial?.serial_number || selectedSerial?.title}/box/${boxNumber}/qr/`, '_blank', 'noopener,noreferrer')}
                                    className="flex items-center gap-2 px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg font-medium transition-colors"
                                >
                                    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"/>
                                    </svg>
                                    {t.downloadQR}
                                </button>
                            ) : (
                                <button
                                    onClick={() => setGenConfirm(true)}
                                    disabled={!selectedSerial || generating}
                                    className="flex items-center gap-2 px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-lg font-medium disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                                >
                                    {generating ? (
                                        <>
                                            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white" />
                                            {t.generating}
                                        </>
                                    ) : (
                                        <>
                                            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" strokeWidth="2" strokeLinejoin="round"/>
                                            </svg>
                                            {t.generateBtn}
                                        </>
                                    )}
                                </button>
                            )}
                        </div>

                        {/* ── Til tanlash ── */}
                        <div className="relative lang-selector">
                            <button
                                onClick={() => setShowLangMenu(!showLangMenu)}
                                className="flex items-center gap-2 px-4 py-2 bg-white border border-gray-300 rounded-lg hover:bg-gray-50"
                            >
                                <span className="text-2xl">{langFlags[language]}</span>
                                <span className="font-medium text-gray-700">{language.toUpperCase()}</span>
                                <svg className={`w-4 h-4 text-gray-500 transition-transform ${showLangMenu ? 'rotate-180' : ''}`}
                                     fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                </svg>
                            </button>
                            {showLangMenu && (
                                <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-50">
                                    {['uzb', 'rus', 'eng', 'chn'].map(lang => (
                                        <button
                                            key={lang}
                                            onClick={() => { setLanguage(lang); setShowLangMenu(false); }}
                                            className={`w-full flex items-center gap-3 px-4 py-3 hover:bg-gray-50 ${language === lang ? 'bg-blue-50' : ''}`}
                                        >
                                            <span className="text-2xl">{langFlags[lang]}</span>
                                            <span className={`font-medium ${language === lang ? 'text-blue-600' : 'text-gray-700'}`}>
                                                {translations[lang].langName}
                                            </span>
                                        </button>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <div className="max-w-7xl mx-auto p-6">

                {/* ── Scan inputs ── */}
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
                    <div className="flex items-center gap-4">
                        <div className="flex-1">
                            <input
                                ref={trackingInputRef}
                                type="text"
                                value={trackingCode}
                                onChange={e => setTrackingCode(e.target.value.toUpperCase())}
                                onKeyDown={handleTrackingKeyDown}
                                placeholder={t.scanPlaceholder}
                                disabled={showModal}
                                maxLength={50}
                                className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>
                        <div className="w-64">
                            <input
                                ref={weightInputRef}
                                type="text"
                                value={weight}
                                onChange={e => setWeight(e.target.value)}
                                onKeyDown={handleWeightKeyDown}
                                placeholder={t.weightPlaceholder}
                                disabled={showModal}
                                maxLength={20}
                                className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>
                        <button
                            onClick={() => { setTrackingCode(''); setWeight(''); trackingInputRef.current?.focus(); }}
                            disabled={showModal}
                            className="p-3 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg"
                        >
                            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                        {canSubmit && !showModal && (
                            <button onClick={() => openModal()}
                                    className="px-8 py-3 bg-gray-700 text-white rounded-lg hover:bg-gray-800 font-medium">
                                {t.submitButton}
                            </button>
                        )}
                    </div>
                </div>

                {/* ── Search ── */}
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 mb-6">
                    <div className="relative">
                        <input
                            ref={searchInputRef}
                            type="text"
                            value={searchQuery}
                            onChange={handleSearch}
                            placeholder={t.search}
                            className="w-full pl-10 pr-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                        <svg className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400"
                             fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                        </svg>
                        {loading && (
                            <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-blue-600" />
                            </div>
                        )}
                    </div>
                </div>

                {/* ── Table ── */}
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
                    {loading && scanRecords.length === 0 ? (
                        <div className="p-16 text-center">
                            <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-blue-600 mx-auto mb-4" />
                            <p className="text-lg text-gray-600">{t.loading}</p>
                        </div>
                    ) : scanRecords.length === 0 ? (
                        <div className="p-16 text-center text-gray-500">
                            <p className="text-lg">{t.noRecords}</p>
                        </div>
                    ) : (
                        <>
                            <table className="w-full">
                                <thead>
                                <tr className="bg-blue-50 border-b">
                                    {[
                                        t.trackingCodeLabel, t.weightLabel, t.clientIdLabel,
                                        t.serialLabel, t.boxNumberLabel, t.productTitleLabel,
                                        t.statusLabel, t.timeLabel
                                    ].map((h, i) => (
                                        <th key={i} className="px-4 py-4 text-left text-xs font-semibold text-gray-700 uppercase">
                                            {h}
                                        </th>
                                    ))}
                                </tr>
                                </thead>
                                <tbody className="divide-y">
                                {scanRecords.map(record => {
                                    const status   = getStatusBadge(record);
                                    const scanTime = new Date(record.scannerUpdatedAt || record.createdAt || record.create_date).getTime();
                                    const isProtected = PROTECTED_LOCATIONS.includes(record.location);
                                    const canEdit  = (Date.now() - scanTime) / 36e5 <= 24 && !isProtected;
                                    const canDelete = canEdit;
                                    return (
                                        <tr key={record.id} className="hover:bg-gray-50">
                                            <td className="px-4 py-4">
                                                <div className="flex items-center gap-3">
                                                    <button
                                                        onClick={() => canEdit && openEditModal(record)}
                                                        disabled={!canEdit}
                                                        className={`transition-colors ${canEdit ? 'text-gray-400 hover:text-blue-600 cursor-pointer' : 'text-gray-300 cursor-not-allowed opacity-50'}`}
                                                    >
                                                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                                                  d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                                                        </svg>
                                                    </button>
                                                    <button
                                                        onClick={() => canDelete && handleDelete(record)}
                                                        disabled={!canDelete}
                                                        className={`transition-colors ${canDelete ? 'text-gray-400 hover:text-red-600 cursor-pointer' : 'text-gray-300 cursor-not-allowed opacity-50'}`}
                                                        title={canDelete ? "O'chirish" : isProtected ? t.deleteLocationBlocked : t.deleteTimeExpired}
                                                    >
                                                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                                                  d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                        </svg>
                                                    </button>
                                                    <span className="text-sm font-medium text-blue-600">
                                                            {record.trackingNumber || record.track_code}
                                                        </span>
                                                </div>
                                            </td>
                                            <td className="px-4 py-4 text-sm text-gray-900">{record.weight}</td>
                                            <td className="px-4 py-4 text-sm text-blue-600">{record.clientCode || record.code}</td>
                                            <td className="px-4 py-4 text-sm text-gray-700 font-medium">{record.serial_number}</td>
                                            <td className="px-4 py-4 text-sm text-gray-700">
                                                    <span className="inline-block bg-blue-50 text-blue-700 border border-blue-200 rounded-full px-3 py-0.5 text-xs font-bold">
                                                        {record.box_number || '—'}
                                                    </span>
                                            </td>
                                            <td className="px-4 py-4 text-sm text-gray-700 max-w-[180px] truncate" title={record.product_title}>
                                                {record.product_title || '—'}
                                            </td>
                                            <td className="px-4 py-4">
                                                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${status.color}`}>
                                                        {status.text}
                                                    </span>
                                            </td>
                                            <td className="px-4 py-4 text-sm text-gray-500">
                                                {formatDate(record.scannerUpdatedAt || record.createdAt || record.create_date)}
                                            </td>
                                        </tr>
                                    );
                                })}
                                </tbody>
                            </table>

                            {totalPages > 1 && (
                                <div className="bg-gray-50 px-6 py-4 border-t flex justify-between items-center">
                                    <div className="text-sm text-gray-700">
                                        {t.showing} {((currentPage - 1) * recordsPerPage) + 1}–{Math.min(currentPage * recordsPerPage, totalCount)} {t.of} {totalCount} {t.records}
                                    </div>
                                    <div className="flex gap-2">
                                        <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}
                                                className="px-3 py-1.5 border rounded-lg disabled:opacity-50">←</button>
                                        {getPageNumbers().map((page, i) => (
                                            page === '...'
                                                ? <span key={i} className="px-3 py-1.5">...</span>
                                                : <button key={i} onClick={() => handlePageChange(page)}
                                                          className={`px-3 py-1.5 rounded-lg ${currentPage === page ? 'bg-blue-600 text-white' : 'border'}`}>
                                                    {page}
                                                </button>
                                        ))}
                                        <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}
                                                className="px-3 py-1.5 border rounded-lg disabled:opacity-50">→</button>
                                    </div>
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>

            {/* ════════════════ SERIAL CHANGE CONFIRM ════════════════ */}
            {showSerialConfirm && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-sm w-full" onClick={e => e.stopPropagation()}>
                        <h2 className="text-xl font-bold mb-2 text-purple-700">{t.serialChangeTitle}</h2>
                        <p className="text-gray-600 mb-2">
                            <strong className="text-gray-900">{pendingSerial?.serial_number || pendingSerial?.title}</strong>
                        </p>
                        <p className="text-gray-500 text-sm mb-6">{t.serialChangeMsg}</p>
                        <div className="flex gap-3">
                            <button
                                onClick={() => { setShowSerialConfirm(false); setPendingSerial(null); }}
                                className="flex-1 px-4 py-2.5 border-2 rounded-lg hover:bg-gray-50"
                            >
                                {t.cancel}
                            </button>
                            <button
                                onClick={confirmSerialChange}
                                className="flex-1 px-4 py-2.5 bg-purple-600 text-white rounded-lg hover:bg-purple-700 font-medium"
                            >
                                {t.serialChangeConfirm}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* ════════════════ GENERATE CONFIRM ════════════════ */}
            {genConfirm && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-xl shadow-2xl p-8 max-w-md w-full">
                        <h2 className="text-xl font-bold mb-3">{t.generateConfirmTitle}</h2>
                        <p className="text-gray-600 mb-6">
                            <strong className="text-gray-900">"{selectedSerial?.serial_number || selectedSerial?.title}"</strong>{' '}
                            {t.generateConfirmMsg}
                        </p>
                        <div className="flex gap-3">
                            <button onClick={() => setGenConfirm(false)}
                                    className="flex-1 px-4 py-2.5 border-2 rounded-lg hover:bg-gray-50">
                                {t.cancel}
                            </button>
                            <button onClick={doGenerate}
                                    className="flex-1 px-4 py-2.5 bg-purple-600 text-white rounded-lg hover:bg-purple-700 font-medium">
                                {t.generateConfirmOk}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* ════════════════ SAVE / EDIT MODAL ════════════════ */}
            {showModal && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 overflow-y-auto"
                    onClick={e => { if (e.target === e.currentTarget) closeModal(); }}
                >
                    <div className="bg-white rounded-lg shadow-2xl p-8 max-w-md w-full my-8"
                         onClick={e => e.stopPropagation()}>

                        <h2 className="text-2xl font-bold mb-6">
                            {editMode ? t.edit : t.modalTitle}
                        </h2>

                        <div className="space-y-4 mb-6">

                            {/* Trek raqam */}
                            <div>
                                <label className="block text-sm font-medium mb-2">{t.trackingCodeLabel}</label>
                                <input
                                    type="text"
                                    value={modalData.trackingCode}
                                    onChange={e => editMode && setModalData({ ...modalData, trackingCode: e.target.value.toUpperCase() })}
                                    onKeyDown={editMode ? makeEnterNav(t.trackingCodeLabel, modalWeightInputRef) : undefined}
                                    disabled={!editMode}
                                    className={`w-full px-4 py-2.5 border rounded-lg ${editMode ? 'border-blue-500' : 'bg-gray-50'}`}
                                />
                            </div>

                            {/* Og'irlik */}
                            <div>
                                <label className="block text-sm font-medium mb-2">{t.weightLabel}</label>
                                <input
                                    ref={modalWeightInputRef}
                                    type="text"
                                    value={modalData.weight}
                                    onChange={e => setModalData({ ...modalData, weight: e.target.value })}
                                    onKeyDown={makeEnterNav(t.weightLabel, clientIdInputRef)}
                                    className="w-full px-4 py-2.5 border border-blue-500 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-300"
                                />
                            </div>

                            {/* Mijoz kodi */}
                            <div>
                                <label className="block text-sm font-medium mb-2">{t.clientIdLabel}</label>
                                <input
                                    ref={clientIdInputRef}
                                    type="text"
                                    value={clientId}
                                    onChange={e => {
                                        const v   = e.target.value;
                                        const max = v.startsWith('99') ? 9 : 6;
                                        if (v.length <= max) setClientId(v);
                                    }}
                                    onKeyDown={makeEnterNav(t.clientIdLabel, editMode ? modalBoxInputRef : productCodeInputRef)}
                                    placeholder={t.clientIdPlaceholder}
                                    maxLength={9}
                                    className={`w-full px-4 py-2.5 border-2 rounded-lg focus:outline-none focus:ring-2 ${
                                        clientId.length > 0 && !isClientIdValid()
                                            ? 'border-red-400 focus:ring-red-300'
                                            : 'border-blue-500 focus:ring-blue-300'
                                    }`}
                                />
                                <p className="text-xs text-gray-400 mt-1 text-right">
                                    {clientId.length} / {getClientIdMaxLength()}
                                    {clientId.startsWith('99') && <span className="ml-2 text-blue-500">99-prefix: 8</span>}
                                </p>
                            </div>

                            {/* Karobka — faqat edit modeda */}
                            {editMode && (
                                <div>
                                    <label className="block text-sm font-medium mb-2">{t.boxLabel}</label>
                                    <input
                                        ref={modalBoxInputRef}
                                        type="number" min="1"
                                        value={modalBoxNumber}
                                        onChange={e => setModalBoxNumber(e.target.value)}
                                        onKeyDown={makeEnterNav(t.boxLabel, productCodeInputRef)}
                                        className="w-full px-4 py-2.5 border-2 border-blue-500 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-300"
                                    />
                                </div>
                            )}

                            {/* TN VED — oxirgi maydon, Enter → save */}
                            <div>
                                <label className="block text-sm font-medium mb-2">{t.productCodeLabel}</label>
                                <input
                                    ref={productCodeInputRef}
                                    type="text"
                                    value={productCode}
                                    onChange={e => setProductCode(e.target.value)}
                                    onKeyDown={handleLastEnter}
                                    placeholder={t.productCodePlaceholder}
                                    className="w-full px-4 py-2.5 border-2 border-blue-500 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-300"
                                />
                                <p className="text-xs text-gray-400 mt-1">
                                    {t.productCodeHint}
                                    {' '}
                                    <kbd className="bg-gray-100 border border-gray-300 rounded px-1.5 py-0.5 text-xs">Enter</kbd>
                                    {' '}→ {t.save}
                                </p>
                            </div>
                        </div>

                        {/* Tugmalar */}
                        <div className="flex gap-3">
                            <button onClick={closeModal} disabled={isSaving}
                                    className="flex-1 px-4 py-2.5 border-2 rounded-lg hover:bg-gray-50 disabled:opacity-50">
                                {t.cancel}
                            </button>
                            <button onClick={handleSubmit} disabled={!isClientIdValid() || isSaving}
                                    className="flex-1 px-4 py-2.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed">
                                {isSaving ? (
                                    <span className="flex items-center justify-center gap-2">
                                        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white" />
                                        {t.loading}
                                    </span>
                                ) : (editMode ? t.save : t.confirm)}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}